import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getRequiredIncreaseInContributionsBarChartKey = 'getRequiredIncreaseInContributionsBarChart';
export interface RequiredIncreaseInContributionsBarChartState {
  loadRequiredIncreaseInContributionsBarChartResponse: IDistributionChart[];
  loadRequiredIncreaseInContributionsBarChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: RequiredIncreaseInContributionsBarChartState = {
  loadRequiredIncreaseInContributionsBarChartResponse: undefined,
  loadRequiredIncreaseInContributionsBarChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadRequiredIncreaseInContributionsBarChart, (state, action) => ({
    ...state
  })),
  on(actions.loadRequiredIncreaseInContributionsBarChartSuccess, (state, action) => ({
    ...state,
    loadRequiredIncreaseInContributionsBarChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadRequiredIncreaseInContributionsBarChartFailure, (state, action) => ({
    ...state,
    loadRequiredIncreaseInContributionsBarChartResponseFailure: action.error
  }))
);

export const getRequiredIncreaseInContributionsBarChart = (state: RequiredIncreaseInContributionsBarChartState) => {
  if (state && state.loadRequiredIncreaseInContributionsBarChartResponse)
    return JSON.parse(JSON.stringify(state.loadRequiredIncreaseInContributionsBarChartResponse));
  else return null;
};

export const getRequiredIncreaseInContributionsBarChartIsLoaded = (state: RequiredIncreaseInContributionsBarChartState) => {
  state.loaded;
};
